import { jsx } from "react/jsx-runtime";
import styled, { keyframes } from "styled-components";
import { token } from "./token.js";
function Buffer({
  color = "default",
  noCornerRadius,
  ...props
}) {
  return /* @__PURE__ */ jsx(Track, {
    $color: color,
    $noCornerRadius: noCornerRadius,
    ...props,
    children: /* @__PURE__ */ jsx(Fill, {})
  });
}
const Track = styled.div.withConfig({
  displayName: "Track",
  componentId: "sc-ln4i1j-0"
})(["overflow:hidden;height:4px;border-radius:", ";background:", ";"], (props) => props.$noCornerRadius ? "0" : token.radiusPill, (props) => props.$color === "brand" ? token.brandPrimary500 : `
				linear-gradient(
					0deg,
					rgb(${token["white-rgb"]} / 30%),
					rgb(${token["white-rgb"]} / 30%)
				),
				${token.gray100a}
			`);
const progress = keyframes`
  to {
    transform: translateX(-40px);
  }
`;
const light = `rgb(${token["white-rgb"]} / 0.15)`;
const dark = `rgb(${token["gray1000-rgb"]} / 0.15)`;
const Fill = styled.div.withConfig({
  displayName: "Fill",
  componentId: "sc-ln4i1j-1"
})(["width:calc(100% + 60px);height:100%;background-image:linear-gradient( -45deg,", " 25%,", " 25%,", " 50%,", " 50%,", " 75%,", " 75%,", " );background-size:40px 40px;background-repeat:repeat-x;animation:", " 0.8s linear infinite;"], light, dark, dark, light, light, dark, dark, progress);
export {
  Buffer,
  Fill,
  Track
};
//# sourceMappingURL=Buffer.js.map
